module.exports = __webpack_public_path__ + "static/media/bingo-ball_04.1e2ac789.png";